import { render, staticRenderFns } from "./BalanceCard.htm?vue&type=template&id=586d0a7d&scoped=true&"
import script from "./BalanceCard.js?vue&type=script&lang=js&"
export * from "./BalanceCard.js?vue&type=script&lang=js&"
import style0 from "./BalanceCard.scss?vue&type=style&index=0&id=586d0a7d&lang=scss&scoped=true&"
import style1 from "../WalletCard.scss?vue&type=style&index=1&id=586d0a7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d0a7d",
  null
  
)

export default component.exports